<template>
  <el-dialog title="修改密码"
    :visible.sync="visible"
    width="400px"
    append-to-body
    @closed='handleClose'
    :close-on-press-escape="false">
    <el-form :model="pwd"
      :rules="rules"
      ref="ruleForm"
      label-width="90px">
      <el-form-item label="旧密码:"
        prop="oldPassword">
        <el-input type="password"
          v-model="pwd.oldPassword"></el-input>
      </el-form-item>
      <el-form-item label="新密码:"
        prop="newPassword">
        <el-input type="password"
          v-model="pwd.newPassword"></el-input>
      </el-form-item>
      <el-form-item label="确认密码:"
        prop="cNewPassword">
        <el-input type="password"
          v-model="pwd.cNewPassword"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'password-modal',
  props: {
    account: [String, undefined],
    callback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      pwd: {
        oldPassword: '',
        newPassword: '',
        cNewPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
          // { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/, message: '密码须由有数字和字母组成的长度为6-12个字符', trigger: 'blur' }
        ],
        cNewPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.pwd.newPassword) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('common/modifypassword', {
            payload: {
              account: this.account,
              oldPassword: this.pwd.oldPassword,
              newPassword: this.pwd.newPassword
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              setTimeout(() => {
                this.$message.success('请重新登录')
                this.callback && this.callback()
              }, 500)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
